import { useScrollAnimation } from "../../hooks/useScrollAnimation";
import { Crosshair, Clock, Flame } from "lucide-react";

const cards = [
  {
    title: "Blind targeting",
    description:
      "Targeting zip codes, at best. No visibility into which specific homes need product, or when.",
    icon: Crosshair,
    iconColor: "#EF4444",
  },
  {
    title: "Stale signals",
    description:
      "By the time a permit is filed, the homeowner has already decided. You're reacting, not leading.",
    icon: Clock,
    iconColor: "#EAB308",
  },
  {
    title: "Expensive reach",
    description:
      "Trade shows and mass campaigns burn budget on homes that will never convert.",
    icon: Flame,
    iconColor: "#F97316",
  },
];

export const OpportunitySection = () => {
  const [headerRef, headerVisible] = useScrollAnimation();
  const [cardsRef, cardsVisible] = useScrollAnimation({ threshold: 0.2 });

  return (
    <section
      className="py-24 px-[5%] border-t border-[#1e1e1e]"
      data-testid="reality-section"
    >
      <div className="max-w-content mx-auto">
        <div
          ref={headerRef}
          style={{
            opacity: headerVisible ? 1 : 0,
            transform: headerVisible ? "translateY(0)" : "translateY(30px)",
            transition: "opacity 0.7s ease-out, transform 0.7s ease-out",
          }}
        >
          <p className="text-[0.7rem] font-semibold tracking-[3px] uppercase text-[#6b7280] mb-6">
            THE OPPORTUNITY
          </p>
          <h2 className="text-[clamp(2rem,4vw,3rem)] font-medium tracking-[-0.5px] leading-[1.2] text-white mb-4 max-w-3xl">
            Millions of homes need your products.{" "}
            <span className="text-[#3b82f6]">You just can't see them.</span>
          </h2>
          <p className="text-[1rem] text-[#9ca3af] mb-16 max-w-2xl">
            Building product companies spend more money marketing to homeowners
            who aren't a fit than talking to those who are.
          </p>
        </div>

        <div 
          ref={cardsRef}
          className="grid grid-cols-1 md:grid-cols-3 border border-[#1e1e1e] rounded-[12px] overflow-hidden"
        >
          {cards.map((card, idx) => (
            <div
              key={idx}
              className={`p-8 ${
                idx < cards.length - 1
                  ? "md:border-r border-b md:border-b-0 border-[#1e1e1e]"
                  : ""
              }`}
              style={{
                opacity: cardsVisible ? 1 : 0,
                transform: cardsVisible ? "translateY(0)" : "translateY(20px)",
                transition: `opacity 0.6s ease-out ${0.1 + idx * 0.1}s, transform 0.6s ease-out ${0.1 + idx * 0.1}s`,
              }}
              data-testid={`reality-card-${idx}`}
            >
              <card.icon className="w-6 h-6 mb-4" style={{ color: card.iconColor }} />
              <h3 className="text-[1.1rem] font-semibold text-white mb-2">
                {card.title}
              </h3>
              <p className="text-[15px] md:text-[0.875rem] text-[#9ca3af] leading-relaxed">
                {card.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
